import React, { useState, useRef, useEffect } from "react";
import { any, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LoadMore from "../../../atoms/loadmore";
import translate from "../../../translate";

import "./read-full-article.m.css";

const ReadFullArticle = ({ children, publisherName }) => {
  const [readMore, setReadMore] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const elementHeight = ref.current.clientHeight;
    if (elementHeight > 650) {
      setReadMore(true);
    }
  }, []);

  const handleReadMore = () => setReadMore(false);

  return (
    <>
      <div styleName={`wrapper ${readMore ? "hide-content" : ""}`} ref={ref}>
        {children}
      </div>
      {readMore && (
        <div styleName="read-more">
          <LoadMore
            onClick={handleReadMore}
            content={translate(publisherName, "read_full_artcile")}
            id="read-full-article"
          />
        </div>
      )}
    </>
  );
};

ReadFullArticle.propTypes = {
  children: any,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(ReadFullArticle);
